import React, { useState } from 'react';
import './Projects.css';
import powerChess from '../pic/power-chess.png';
import teamUp from '../pic/TeamUp.png';
import sprintSpark from '../pic/sprintspark0.png';
import sprintSpark1 from '../pic/sprintspark1.png';
import sprintSpark2 from '../pic/sprintspark2.png';
import sprintSpark3 from '../pic/sprintspark3.png';
import sprintSpark4 from '../pic/sprintspark4.png';
import sprintSpark5 from '../pic/sprintspark5.png';
import sprintSpark6 from '../pic/sprintspark6.png';
import motifSong from '../pic/motif1.png';
import motifSong2 from '../pic/motif2.png';
import motifSong3 from '../pic/motif3.png';
import motifSong4 from '../pic/motif4.png';
import checkMark from '../pic/checkmark1.png';
import checkMark2 from '../pic/checkmark2.png';
import checkMark3 from '../pic/checkmark3.png';
import musiciansClub from '../pic/musiciansclub1.png';
import musiciansClub2 from '../pic/musiciansclub2.png';
import musiciansClub3 from '../pic/musiciansclub3.png';
import musiciansClub4 from '../pic/musiciansclub4.png';
import musiciansClub5 from '../pic/musiciansclub5.png';

const projects = [
  {
    title: "The Musicians Club",
    link: "https://themusiciansclub.net/",
    description: "Revamped the Shopify homepage and developed a community forum to boost engagement and sales. Implemented a responsive menu and online tutoring system.",
    stack: "Shopify, HTML, CSS, JavaScript, Wix, Trello, Slack",
    image: musiciansClub,
    images: [musiciansClub, musiciansClub2, musiciansClub3, musiciansClub4, musiciansClub5],
  },
  {
    title: "Power Chess",
    description: "A multiplayer Chinese Chess web application to play with friends, random opponents, or solo.",
    stack: "Vite, PHP, MySQL, Apache",
    image: powerChess,
  },
  {
    title: "Team Up",
    link: "https://team-up-xi.vercel.app/",
    description: "A gaming forum that displays top streamers by game. Includes XP-based user levels and a player finder.",
    stack: "React, Twitch API, SQLite, Django, Vercel, Railway",
    image: teamUp,
  },
  {
    title: "Motif Song",
    link: "https://www.motif-song.org/",
    description: "A song recommendation platform using Spotify's API with search, saved tracks, and trending artists.",
    stack: "React, Node.js, Express, Nginx, PostgreSQL, AWS EC2, Spotify API",
    image: motifSong,
    images: [motifSong, motifSong2, motifSong3, motifSong4],
  },
  {
    title: "Check Mark",
    description: "A todo list app with sorting by priority, week, or date. Built for productivity enthusiasts.",
    stack: "React, Django, SQLite, Nginx, AWS EC2, CloudFront, S3, Gunicorn, Supervisor",
    image: checkMark,
    images: [checkMark, checkMark2, checkMark3],
  },
  {
    title: "Sprint Spark",
    description: "A full-stack workflow automation platform unifying Jira, GitHub, and Confluence to streamline sprint management. Features automated story creation, metrics dashboards, and an AI chatbot.",
    stack: "Django REST, React, AWS, Docker, GitHub Actions, JMeter",
    image: sprintSpark,
    images: [sprintSpark, sprintSpark1, sprintSpark2, sprintSpark3, sprintSpark4, sprintSpark5, sprintSpark6],
  }
];

const ImageCarousel = ({ images, onClose }) => {
  const [index, setIndex] = useState(0);

  const handlePrev = () => setIndex((index - 1 + images.length) % images.length);
  const handleNext = () => setIndex((index + 1) % images.length);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="carousel-container" onClick={e => e.stopPropagation()}>
        <button className="carousel-close" onClick={onClose}>×</button>
        <div className="carousel-modal">
          <img src={images[index]} alt="carousel-img" className="carousel-image" />
          {images.length > 1 && (
            <>
              <button className="carousel-arrow left" onClick={handlePrev}>&lt;</button>
              <button className="carousel-arrow right" onClick={handleNext}>&gt;</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};




const Projects = () => {
  const [carouselImages, setCarouselImages] = useState(null);

  const handleImageClick = (project) => {
    if (project.images) {
      setCarouselImages(project.images);
    }
  };

  return (
    <div className='projects-section'>
      <h2 className="section-title">&lt;Projects&gt;</h2>
      <div className="projects-grid">
      {projects.map((project, index) => (
  <div
    key={index}
    className={`project-card ${project.images ? 'has-images' : 'no-images'}`}
    onClick={() => handleImageClick(project)}
  >
    <div className="project-img-wrapper" style={{ position: 'relative' }}>
      <img
        src={project.image}
        alt={`${project.title}-Image`}
        className="project-img"
      />
    </div>
    
    {project.images && project.images.length > 1 && (
      <div className="carousel-dots">
        {project.images.map((_, i) => (
          <span key={i} className="dot"></span>
        ))}
      </div>
    )}
    
    <div className="project-info">
      {project.link ? (
        <a
          href={project.link}
          target="_blank"
          rel="noopener noreferrer"
          className="project-title"
          onClick={(e) => e.stopPropagation()}
        >
          {project.title}
        </a>
      ) : (
        <span className="project-title">{project.title}</span>
      )}
      <p className="project-desc">{project.description}</p>
      <p className="project-stack">
        <b>Tech stack:</b> {project.stack}
      </p>
    </div>
  </div>
))}

      </div>
      {carouselImages && <ImageCarousel images={carouselImages} onClose={() => setCarouselImages(null)} />}
    </div>
  );
};


export default Projects;
